/***********
 * 项目团队
 **************/
import LaborDetailTitleValue from "./LaborDetailTitleValue.vue";
import LaborDetailKeyValue from "./LaborDetailKeyValue.vue";
const columns2 = [{
  title: "序号",
  dataIndex: "sortIndex",
  key: "sortIndex",
  width: 80,
  scopedSlots: {
    customRender: "sortIndex"
  }
}, {
  title: "姓名",
  dataIndex: "name",
  key: "name",
  ellipsis: true
}, {
  title: "所在单位",
  dataIndex: "work_unit",
  key: "work_unit"
}, {
  title: "专业技术职务",
  dataIndex: "technical_position",
  key: "technical_position"
}, {
  title: "行政职务",
  dataIndex: "administrator_position",
  key: "administrator_position"
}, {
  title: "承担任务",
  dataIndex: "task",
  key: "task"
}, {
  title: "备注",
  dataIndex: "comment",
  key: "comment"
}];
const columns3 = [{
  title: "序号",
  dataIndex: "sortIndex",
  key: "sortIndex",
  width: 80,
  scopedSlots: {
    customRender: "sortIndex"
  }
}, {
  title: "姓名",
  dataIndex: "name",
  key: "name",
  ellipsis: true
}, {
  title: "所在单位",
  dataIndex: "work_unit",
  key: "work_unit"
}, {
  title: "专业技术职务",
  dataIndex: "technical_position",
  key: "technical_position"
}, {
  title: "行政职务",
  dataIndex: "administrator_position",
  key: "administrator_position"
}, {
  title: "承担任务",
  dataIndex: "task",
  key: "task"
}, {
  title: "备注",
  dataIndex: "comment",
  key: "comment"
}];
export default {
  components: {
    LaborDetailTitleValue,
    LaborDetailKeyValue
  },
  props: {
    laboratoryItemDetail: {
      type: Object
    },
    moudleName: {
      type: String
    }
  },

  data() {
    return {
      columns2,
      columns3,
      teamDetail1: [],
      teamDetail2: [],
      teamDetail3: []
    };
  },

  created() {
    this.getTeamDetail1(this.$utils.getUrlParams('detailId'));
    this.getTeamDetail2(this.$utils.getUrlParams('detailId'));
    this.getTeamDetail3(this.$utils.getUrlParams('detailId'));
  },

  methods: {
    async getTeamDetail1(vr_id) {
      const data = await this.$http.getVRTeamByParam({
        type: 1,
        vr_id: vr_id
      });
      this.teamDetail1 = data.content && Array.isArray(data.content) && data.content.length > 0 ? data.content[0] : [];
    },

    async getTeamDetail2(vr_id) {
      const data = await this.$http.getVRTeamByParam({
        type: 2,
        vr_id: vr_id
      });
      this.teamDetail2 = data.content;
    },

    async getTeamDetail3(vr_id) {
      const data = await this.$http.getVRTeamByParam({
        type: 3,
        vr_id: vr_id
      });
      console.log(data, 'dddd');
      this.teamDetail3 = data.content;
    }

  }
};